import {
  sliceSpecialLoadFail,
  sliceSpecialLoadHandle,
} from 'utils/tools/slice-actions';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { createSlice } from 'utils/@reduxjs/toolkit';
import { landingPageSaga } from './saga';

export const initialState = {
  loading: false,
  error: null,
  landingPageData: [],
};

export const LandingPageActionTypes = {
  SUBMIT_CALLBACK: 'submitCallback',
};

const slice = createSlice({
  name: 'landingPage',
  initialState,
  reducers: {
    submitCallbackStart(state) {
      sliceSpecialLoadHandle(
        state,
        LandingPageActionTypes.SUBMIT_CALLBACK,
        true,
      );
    },
    updateActionEnd(state, action) {
      const { actionFor, data = null } = action.payload;
      sliceSpecialLoadHandle(state, actionFor, false, data);
    },
    updateActionError(state, action) {
      const { actionFor, error } = action.payload;
      sliceSpecialLoadFail(state, actionFor, error);
    },
  },
});

export const { actions: landingPageActions } = slice;

export const useLandingPageSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: landingPageSaga });
  return { actions: slice.actions };
};
